<template>
  <AIController />
</template>

<script>
import AIController from '@/components-v2/presentation-editor/side-right/right-nav/AIController.vue'

export default {
  title: 'Create',
  name: 'AIEditPanel',
  components: {
    AIController,
  },
}
</script>
